import React from "react";


export default function promo() {
    return (
        <>
            <div className="mainpromo">
                <div className="promo2">
                    <h1 className="promo1" >Food and Beverage Restaurant Promotion</h1>
                </div>
                <div className="promo2">
                    <div>
                        <h1>1. Leverage a Big Local Event</h1>
                        <p>Plan a promotion around a big event nearby, like a local sporting event, concert, or festival. This helps drive business and generate awareness of your restaurant to a large audience. You’ll essentially be riding off the coattails of that event’s marketing.

                            Examples: Offer 5% off to people who have a ticket to a local hockey game, or $5 off any purchase before a concert that’s down the street.</p>
                    </div>
                    <div className="promo2">
                        <h1>2. Charities & Celebrities</h1>
                        <p>Bringing in a celebrity, even a local one, can be expensive. But you can potentially entice them by donating a portion of the day’s proceeds to a charity of their choosing. Joining forces with a big name will not only draw people to your restaurant, but show the community that you care about a good cause.

                            Examples: Have a celebrity bartend from 4-8pm, and give all proceeds from pizzas sold during that time to your local food bank.</p>
                    </div>
                    <div className="promo2">
                        <h1>3. Holidays</h1>
                        <p>How can you celebrate the holidays with your customers? What will inspire them to share, link, and tag you in the event content they post on their social channels? Create an event that's so special they can't resist to post about it — and bring their friends back next year.

                            Examples: Halloween costume contests featuring giveaways or gifts, a different offering for each of the twelve days of Christmas, a Mother’s Day trivia event.</p>
                    </div>

                    <div className="promo2">
                        <h1>4. Loyalty Offerings</h1>
                        <p>The key is picking a high enough threshold for a free meal or a discount to make it worthwhile for you. It helps to get your guests to opt in easily with the use of restaurant loyalty technology.

                            Examples: Buy nine coffees and get one free, purchase every beer on the list and get 10% off beers for the year. </p>
                    </div>


                </div>

            </div>

        </>
    );
}